
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

const AutoLogin = () => {
  const [checkingAutoLogin, setCheckingAutoLogin] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    (async () => {
      try {
        // console.log("CHILD: window.location.href =", window.location.href);
        const query = new URLSearchParams(window.location.search);
        const encodedPayload = query.get("payload");
        // console.log("CHILD: encodedPayload =", encodedPayload);

        if (!encodedPayload) {
          setCheckingAutoLogin(false);
          return;
        }
        const decoded = decodeURIComponent(encodedPayload);

        // // Decode Base64 payload
        // const decodedString = atob(encodedPayload);
        // const payload = JSON.parse(decodedString);
        // console.log("CHILD: decodedPayload =", payload);
        //   const payload = JSON.parse(encodedPayload);
        const payload = JSON.parse(decoded);

        const reqBody = {
          company_domain: payload.company_domain,
          email: payload.email,
          password: payload.password, // use as-is, not decoded
          integration_type: payload.integration_type,
        };
        //   console.log("CHILD: decodedPayload =", payload);


        console.log("Decoded Payload:", payload);
        // console.log("CHILD: sending login request...", reqBody);

        const response = await fetch(
          `${process.env.REACT_APP_API_BASE_URL}api/v1/auth/login`,
          {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(reqBody),
          }
        );

        console.log("CHILD: fetch response status =", response.status);

        if (!response.ok) {
          console.warn("CHILD: Login failed:", response.statusText);
          setCheckingAutoLogin(false);
          return;
        }

        const respJson = await response.json();
        // console.log("CHILD: response JSON =", respJson);

        if (!respJson.token) {
          console.warn("CHILD: No token in response");
          setCheckingAutoLogin(false);
          return;
        }

        // Save user info
        const userInfoToSession = {
          user_details: respJson.user_details,
          token: respJson.token,
          userEmail: respJson.email,
          userPhone: respJson.userPhone,
          firstName: respJson.firstName,
        };
        localStorage.removeItem("menuLoaded");
        sessionStorage.setItem("atsuser-info", JSON.stringify(userInfoToSession));
        document.cookie = `userinfoCookie=${encodeURIComponent(
          JSON.stringify(userInfoToSession)
        )}; path=/`;

        console.log("CHILD: Auto-login success → navigating to dashboard");
        navigate("/ats-dashboard");
      } catch (err) {
        console.error("CHILD: Auto-login error:", err);
        setCheckingAutoLogin(false);
      }
    })();
  }, [navigate]);

  if (checkingAutoLogin) {
    return <div>Signing you in...</div>;
  }

  return <div>Auto-login failed. Please log in manually.</div>;
};

export default AutoLogin;
